import { themeSpaces } from '../../../theme/foundations';
export var actionBarTheme = {
  baseStyle: {
    container: {
      position: 'absolute',
      // The component should be as wide as the parent container and with 48px gaps on the sides.
      width: "calc(100% - ".concat(themeSpaces['xxl'], " * 2)"),
      bottom: 0,
      left: '50%',
      // `transform` is necessary not only for positioning but also to behave as the containing block of chakra's animation component.
      // https://developer.mozilla.org/en-US/docs/Web/CSS/position#types_of_positioning
      transform: 'translateX(-50%)'
    },
    bar: {
      minHeight: '72px',
      borderRadius: 'l',
      paddingX: 'm',
      paddingY: 's',
      marginBottom: 'xxl',
      backgroundColor: 'neutral.black',
      color: 'neutral.white',
      display: 'flex',
      flexDirection: {
        xs: 'column',
        s: 'row'
      },
      alignItems: {
        xs: 'flex-start',
        s: 'center'
      },
      justifyContent: 'space-between',
      gap: 'xs'
    },
    itemLabel: {
      textStyle: 'body2'
    },
    itemValue: {
      textStyle: 'body2Semi'
    }
  }
};
//# sourceMappingURL=ActionBar.theme.js.map